import faker from '@faker-js/faker';
import loopMap from 'mn-utils/loopMap';
import {TListItem} from './types';

export const getTransactionList = (limit: number): TListItem[] => {
  return loopMap(limit, () => {
    return getTransactionDetails();
  });
};

export const getTransactionDetails = (): TListItem => {
  const statuses = ['completed', 'pending', 'failed', 'requested'];
  const kinds = ['payment_link', 'terminal', 'online', 'refund'];
  const networks = ['bitcoin', 'bsc', 'ethereum', 'ripple', 'tron', 'polkadot'];
  const transaction_kind = (faker.helpers as any).arrayElement(kinds);
  const amount = faker.finance.amount(0, 1000, 2);
  return {
    transaction_kind,
    order_id: faker.datatype.uuid(),
    fiat_amount: faker.finance.amount(0, 1000, 2),
    fiat_code: faker.finance.currencyCode(),
    transaction_status: (faker.helpers as any).arrayElement(statuses),
    date_time: faker.date.recent().toISOString(),
    ...(transaction_kind !== 'terminal' ? {email: faker.internet.email()} : {}),
    auction_id: faker.datatype.uuid(),
    payment_id: faker.datatype.uuid(),
    currency_amount: amount,
    currency_code: faker.finance.currencyCode(),
    fee_code: faker.finance.currencyCode(),
    fee_amount: faker.finance.amount(0, 10, 2),
    retailer_name: faker.name.findName(),
    rate_amount: faker.finance.amount(0, 1000, 2),
    hash: faker.finance.ethereumAddress(),
    ...(faker.datatype.boolean() ? {network: (faker.helpers as any).arrayElement(networks)} : {}),
    ...(faker.datatype.boolean() ? {refund_id: faker.datatype.uuid()} : {}),
    // refunds: getRefundList(faker.mersenne.rand(3)),
    refundable_amount: amount,
  } as TListItem;
};
